import PropTypes from "prop-types";
import classNames from "classnames";

const IconSearch = ({ className, height = "15px", width = "15px" }) => {
    const classes = classNames("searchIcon", className);

    return (
        <svg
            className={classes}
            width={width}
            height={height}
            viewBox="0 0 107.9 105.1"
            focusable="false"
        >
            <g xmlns="http://www.w3.org/2000/svg" id="MagnifierIcon2">
                <path d="M99.5,105c-2,0-4-0.8-5.5-2.3L66.3,74.9c-3-3-3-7.9,0-10.9c3-3,7.9-3,10.9,0l27.7,27.8c3,3,3,7.9,0,10.9 C103.4,104.2,101.4,105,99.5,105z" />
                <path d="M44.8,89.2c-24.3,0-44.1-19.8-44.1-44.1S20.4,1,44.8,1c24.3,0,44.1,19.8,44.1,44.1S69.1,89.2,44.8,89.2z M44.8,16.4c-15.8,0-28.7,12.9-28.7,28.7c0,15.8,12.9,28.7,28.7,28.7c15.8,0,28.7-12.9,28.7-28.7C73.5,29.3,60.6,16.4,44.8,16.4z" />
            </g>
        </svg>
    );
};

IconSearch.propTypes = {
    className: PropTypes.string,
    height: PropTypes.string,
    width: PropTypes.string,
};

export default IconSearch;
